import { events } from '@otto-ec/global-resources/event-q-bus';
import type { Topics } from '@shared/eventBus/eventQBus.types.ts';
import type { EventsIncoming, Unsubscribe } from '@tilelist/application/ports/EventsIncoming.ts';

/**
 *
 *
 */
export function createEventsIncoming(): EventsIncoming {
    const bus = events<Topics>();

    return {
        onPageResolved(handler): Unsubscribe {
            bus.on('ftfind.dresonRule.resolved', handler);
            return () => bus.off('ftfind.dresonRule.resolved', handler);
        },
        oncePageResolved(handler): Unsubscribe {
            bus.once('ftfind.dresonRule.resolved', handler);
            return () => bus.off('ftfind.dresonRule.resolved', handler);
        },
        onComparisonApiReady(handler): Unsubscribe {
            bus.once('ft5.productComparison.loaded', handler);
            return () => bus.off('ft5.productComparison.loaded', handler);
        },
    };
}
